<template>
  <div id="app">
    <AuthLoadingScreen />
    <PasswordGate />
    <router-view />
  </div>
</template>

<script setup>
import AuthLoadingScreen from '@/components/auth/AuthLoadingScreen.vue';
import PasswordGate from '@/components/auth/PasswordGate.vue';
</script>

<style>
/* Global app styles */
#app {
  min-height: 100vh;
  font-family: var(--font-primary);
}
</style>
